import { useEffect, useMemo } from 'react'
import { useEnterpriseAccountVerifyEmail } from 'domains/public/api/auth/email-verification/enterpriseAccountVerifyEmail.hooks'
import { isTokenExpiredError, isNotFoundError } from 'api/utils/apollo/errors/isError.hooks'
import { type DashMessages } from 'intl/intl.types'

interface Props {
  token: string
}

export const useEmailVerificationDetails = ({ token }: Props) => {
  const { verifyEmail, apiLoading, apiSuccess, apiError } = useEnterpriseAccountVerifyEmail()

  useEffect(() => {
    verifyEmail({ rawToken: token })
  }, [token, verifyEmail])

  const errorMessageId: DashMessages | undefined = useMemo(() => {
    if (!apiError) return undefined

    if (isTokenExpiredError(apiError)) {
      return 'public.emailVerification.content.error.expiredToken'
    }

    if (isNotFoundError(apiError)) {
      return 'public.emailVerification.content.error.notFound'
    }

    return 'public.emailVerification.content.error.common'
  }, [apiError])

  return {
    emailVerificationLoading: apiLoading,
    emailVerificationSuccess: apiSuccess,
    errorMessageId,
  }
}
